import type React from 'react';
import './AuthLayout.scss';

export interface AuthLayoutProps {
  /** Small mono kicker above the heading, e.g. "Sign in". */
  eyebrow: string;
  title: string;
  lede: React.ReactNode;
  /** The form. */
  children: React.ReactNode;
  /** Links below the form, e.g. back to sign-in. */
  footer?: React.ReactNode;
}

/**
 * Split-screen shell shared by every /auth/* page: dark brand panel on the
 * left, form column on cream to the right. Matches the Locate2u Orders portal
 * sign-in, which is built from the same tokens as this app.
 */
export const AuthLayout: React.FC<AuthLayoutProps> = ({
  eyebrow,
  title,
  lede,
  children,
  footer,
}) => (
  <div className="auth">
    {/* Dropped below $bp-lg, which is why the form column carries its own
        logo — otherwise a phone gets an unbranded form. */}
    <aside className="auth__panel">
      <img
        src="/assets/l2u-logo-blue.png"
        alt="Locate2u"
        className="auth__panel-logo"
        width={150}
      />

      <div>
        <div className="auth__panel-eyebrow">AI Intelligence</div>
        <h2 className="auth__panel-headline">
          Agents that know your operation, ready when you are.
        </h2>
        <p className="auth__panel-blurb">
          Create named agents with their own purpose, rules and knowledge, chat with them, and
          let them query your live Locate2u account.
        </p>
      </div>

      <div className="auth__panel-legal">© 2026 Locate2u</div>
    </aside>

    <main className="auth__main">
      <div className="auth__column">
        <img
          src="/assets/l2u-logo-classic.png"
          alt="Locate2u"
          className="auth__mobile-logo"
          width={130}
        />

        <div className="auth__eyebrow">{eyebrow}</div>
        <h1 className="auth__title">{title}</h1>
        <p className="auth__lede">{lede}</p>

        {children}

        {footer && <div className="auth__footer">{footer}</div>}
      </div>
    </main>
  </div>
);

export default AuthLayout;
